import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { API_NAMES, ApiServiceBase } from '../api';
import { transactionDateEditingSetting } from '~/models/administration/TransactionDateEditingSetting';

@Injectable({
  providedIn: 'root'
})
export class TransactionDateEditingSettingsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminAssets);
  }

   getTransactionDateEditingSettings() {
    return this.http.get<transactionDateEditingSetting>(this._url());
}

updateTransactionDateEditingSettings(model: any) {
    return this.client.put(this._url(), model);
}

private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/TransactionDateEditingSettings${v}`);
}

}
